import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/component/auth/model/user.model';
import { Node } from 'src/app/component/node/model/node.model';
import { NodesService } from 'src/app/component/node/service/nodes.service';
import { LOGINDETAILS } from 'src/app/component/system/accounts/model/login-audit';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { WorkflowStateTypes } from 'src/app/component/system/workflows/model/workflow-state-types.model';

@Component({
  selector: 'app-reassign-change-node-state',
  templateUrl: './reassign-change-node-state.component.html',
  styleUrl: './reassign-change-node-state.component.scss'
})
export class ReassignChangeNodeStateComponent implements OnInit {
  frmAssignUSer: FormGroup;
  node: Node;
  loadingUsers: boolean = false;
  reassigning: boolean = false;
  releasing: boolean = false;
  currentUser: User;
  chosenEditor: LOGINDETAILS;
  currentEditor: User;
  users: User[] = [];
  workflowStateTypes?: WorkflowStateTypes | any;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ReassignChangeNodeStateComponent>,
    private nodeservice: NodesService, private loginTokenService: LoginTokenService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.frmAssignUSer = this.fb.group({
      frmChosenEditor: ['']
    });

  }

  ngOnInit(): void {
    if (this.data) {
      this.node = this.data;
      this.getUsersByRegion()
    }
  }

  ngAfterViewInit(): void {
  }

  closeWindow() {
    this.dialogRef.close();
  }

  getUsersByRegion() {
    this.loadingUsers = true;
    this.nodeservice.getUsersInMyRegion(this.node, this.workflowStateTypes).subscribe({
      next: (res) => {
        if (res?.users) {
          this.users = res.users;
          const loginDetails = this.node?.NODE_EDITING?.[0]?.LOGIN_DETAILS;
          if (loginDetails) {
            const matchedUser = this.users.find(
              user => user.ID === loginDetails.ID
            );

            if (matchedUser) {
              this.currentEditor = loginDetails;
              this.chosenEditor = loginDetails;
              this.frmAssignUSer.patchValue({ frmChosenEditor: loginDetails.USER_ID });
            }
          }
          this.loadingUsers = false;
        }
      },
      error: (err) => {
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
  }

  trackByUserId(index: number, user: any) {
    return user.ID;
  }

  changeAssign(event: any): void {
    if (!this.chosenEditor) {
      this.reassigning = true;
      const foundUser = this.users.find(user => user.USER_ID === this.frmAssignUSer.get('frmChosenEditor')?.value);
      if (foundUser) {
        this.currentEditor = foundUser;
      }
      return;
    }

    if (this.chosenEditor.USER_ID === this.frmAssignUSer.get('frmChosenEditor')?.value) {
      this.reassigning = false;
    } else {
      this.reassigning = true;
    }

    const foundUser = this.users.find(user => user.USER_ID === this.frmAssignUSer.get('frmChosenEditor')?.value);
    if (foundUser) {
      this.currentEditor = foundUser;
    }
  }

  reassignNode(newEditor: any): void {
    this.reassigning = true;
    this.nodeservice.reassignNode(this.node, newEditor).subscribe({
      next: (res) => {
        if (res?.msg?.SUCCESS && res?.nodeEditor) {
          this.currentUser = this.loginTokenService.getUser();
          if (this.currentUser)
            if (this.currentUser.ID === this.node?.NODE_EDITING?.[0]?.LOGIN_DETAILS?.ID) {
              //this.workbenchBadges.updateAllCount();
            }
          if (this.node?.NODE_EDITING?.length) {
            this.node.NODE_EDITING[0] = res.nodeEditor;
          } else {
            this.node.NODE_EDITING = [res.nodeEditor];
          }
        }
        else if (res?.msg?.SUCCESS === false) {
          //do nothing
        }
        else {
          //do nothing
        }
        this.reassigning = false;
      },
      error: (err) => {
        this.reassigning = false;
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
    this.closeWindow();
  }

  removeEditor(): void {
    this.releasing = true;
    this.nodeservice.removeEditor(this.node).subscribe({
      next: (res) => {
        if (res?.msg?.SUCCESS && res?.nodeEditor) {
          this.currentUser = this.loginTokenService.getUser();
          if (this.currentUser)
            if (this.currentUser.ID === this.node?.NODE_EDITING?.[0]?.LOGIN_DETAILS?.ID) {
              //this.workbenchBadges.updateAllCount();
            }
          if (this.node?.NODE_EDITING?.length) {
            this.node.NODE_EDITING[0] = res.nodeEditor;
          } else {
            this.node.NODE_EDITING = [res.nodeEditor];
          }
        }
        else if (res?.msg?.SUCCESS === false) {
          //do nothing
        }
        else {
          //do nothing
        }
        this.releasing = false;
      },
      error: (err) => {
        this.releasing = false;
        //this.msg = { SUCCESS: false, MSG: 'Error retrieving users.' };
      },
      complete: () => {
        //do nothing
      }
    });
    this.closeWindow();
  }
}
